export const TipoDomicilioArray=[
    {id:'F',display:'FISCAL'},
    {id:'O',display:'OFICINA'},
    {id:'C',display:'CASA'},
]